<template>
    <AdmPanel :loading="loader[LISTED_SENTIMENT+'data']">
        <h2 slot="header_title">{{ isAudit ? '上市公司舆情':'负面事件汇总'}}</h2>
        <div class="adm-buttons" slot="header_buttons">
          <!-- 导出 -->
          <iv-button
              :loading="loader[LISTED_SENTIMENT+'exportPublicSentiment']"
              v-rbac-allow="['listedSentiment','export']"
              type="primary"
              ghost
              class="export-excel-btn"
              icon="md-download"
              @click="exportExcel()"
          >导出</iv-button>
        </div>
        <div class="filter-wrapper">
            <FilterBar
                slot="tools"
                :value="conditions"
                :condition="options.filter_rules"
                :builder="builder"
                @search="changeQuery">
                <iv-form-item>
                <iv-datePicker type="daterange"  placeholder="请选择时间段" v-model="conditions.timeScope" format="yyyy-MM-dd" style="width: 200px;margin-right:20px;"></iv-datePicker>
                </iv-form-item>
                <iv-form-item>
                <iv-button
                    type="info"
                    :disabled="loader[LISTED_SENTIMENT+'data']"
                    @click="changeQuery()">
                    <iv-icon type="md-search" size="14" style="vertical-align:text-bottom" /> 搜索
                </iv-button>
                </iv-form-item>
            </FilterBar>
         </div>
        <div class="adm-panel__tools">
            <span style="width:6em;text-align: right;display: inline-block;">一级指标：</span>
            <iv-select
                v-model="conditions.firstTargetNum"
                filterable
                clearable
                style="width:120px"
                placeholder="一级指标"
                @on-change="changeQuery({ ...conditions,offset:0 });conditions.secondTargetNum = '';conditions.thirdTargetNum = ''"
            >
                <iv-option v-for="item in options.firstTargets" :value="item.id" :key="item.id">{{ item.name }}</iv-option>
            </iv-select>
        </div>
        <div class="adm-panel__tools">
            <span style="width:6em;text-align: right;display: inline-block;">二级指标：</span>
            <iv-select
                v-model="conditions.secondTargetNum"
                filterable
                clearable
                style="width:400px;"
                placeholder="二级指标"
                @on-change="changeQuery({ ...conditions,offset:0 });conditions.thirdTargetNum = ''"
            >
                <iv-option v-for="item in options.secondTargets" :value="item.id" :key="item.id">{{ item.name }}</iv-option>
            </iv-select>
        </div>
        <div class="adm-panel__tools">
            <span style="width:6em;text-align: right;display: inline-block;">三级指标：</span>
            <iv-select
                v-model="conditions.thirdTargetNum"
                filterable
                clearable
                style="width:400px;"
                placeholder="三级指标"
                @on-change="changeQuery({ ...conditions,offset:0 })"
            >
                <iv-option v-for="item in options.thirdTargets" :value="item.id" :key="item.id">{{ item.name }}</iv-option>
            </iv-select>
        </div>
        <iv-card class="adm-checklist" dis-hover :bordered="false" v-if="isAudit && list.data.length > 0 ">
          <iv-checkbox
              :indeterminate="indeterminate"
              :value="checkAll"
              @click.prevent.native="handleCheckAll"> 全选</iv-checkbox>
          <span style="margin-right: 1em">已选 {{ selection.list.length }} 项目，所选项将</span>
          <span class="adm-buttons">
              <iv-button type="primary" :disabled="selection.list.length<=0" size="small" @click="reviewList('pass')">通过</iv-button>
              <iv-button type="primary" ghost size="small" v-if="selection.list.length<=0" :disabled="selection.list.length<=0">不通过</iv-button>
              <iv-poptip ref="selectionPoptipTop" v-model="selection.shown" v-else>
              <iv-button type="primary" ghost size="small" :disabled="selection.list.length<=0">不通过</iv-button>
              <div slot="content" style="text-align: left;">
                  <iv-form label-position="top">
                  <iv-form-item label="审核批注（选填）">
                      <iv-input type="textarea" v-model="selection.comment" />
                  </iv-form-item>
                  <div class="adm-buttons" style="text-align:right">
                      <iv-button type="text" size="small" @click="closeSelectionPoptip('selectionPoptipTop')">
                      取消
                      </iv-button>
                      <iv-button type="primary" size="small" @click="reviewList('fail');closeSelectionPoptip('selectionPoptipTop')">
                      发送
                      </iv-button>
                  </div>
                  </iv-form>
              </div>
              </iv-poptip>
          </span>
        </iv-card>
        <div>
          <p v-if="list.data.length <= 0 " class="text-center">
              <EmptyData>
                  <div class="nextPage" slot="emptyBtn">
                      <iv-button @click="changeQuery()">重新获取</iv-button>
                  </div>
              </EmptyData>
          </p>
          <iv-checkbox-group class="adm-list ui-wrapper" v-model="selection.checkboxData" v-else-if="isAudit" @on-change="checkboxData">
              <ListedOpinionItem
                :value="item"
                type="audit"
                v-for="item in list.data"
                :key="item.id"
                :showLogButton="isAudit && $rbac.allow('operationLog')"
                :showJumpEditBUtton="isAudit && $rbac.allow(['audit','listedSentimentEdit'])"
                @title="title"
                @jumpToEdit="jumpToEdit(item)">
                  <iv-checkbox slot="checkbox" :label="item.id"><span></span></iv-checkbox>
                  <span slot="buttons">
                      <iv-button type="primary" size="small" @click="review('pass',item)">通过</iv-button>
                      <iv-poptip :ref="'selectionPoptipDown' + item.id" v-model='item.shown'>
                      <iv-button type="primary" ghost size="small" style="margin-left:10px">不通过</iv-button>
                      <div slot="content" style="text-align: left;">
                          <iv-form label-position="top">
                          <iv-form-item label="审核批注（选填）">
                              <iv-input type="textarea" v-model="item.comment" />
                          </iv-form-item>
                          <div class="adm-buttons" style="text-align:right">
                              <iv-button type="text" size="small" @click="closeSelectionPoptip('selectionPoptipDown' + item.id )">
                              取消
                              </iv-button>
                              <iv-button type="primary" size="small" @click="review('fail',item);closeSelectionPoptip('selectionPoptipDown' + item.id)">
                              发送
                              </iv-button>
                          </div>
                          </iv-form>
                      </div>
                      </iv-poptip>
                  </span>
              </ListedOpinionItem>
          </iv-checkbox-group>
          <div class="adm-list ui-wrapper" v-else v-for="item in list.data" :key="item.id">
            <ListedOpinionItem :value="item"  :is_confirm="item.is_confirm"  type="audit">
            <span class="adm-buttons" slot="buttons">
              <iv-button v-rbac-allow="['listedSentiment','edit']" size='small' type="primary" @click="confirm(item,1)">修改</iv-button>
              <iv-poptip
                confirm
                :title="`确认排除？`"
                @on-ok="exclude(item,2,true)">
                <iv-button v-rbac-allow="['listedSentiment','edit']" size='small' type="primary" ghost>排除</iv-button>
              </iv-poptip>
            </span>
            </ListedOpinionItem>
          </div>
        </div>

        <iv-card class="adm-checklist" dis-hover :bordered="false" v-if="isAudit && list.data.length > 0 ">
          <iv-checkbox
              :indeterminate="indeterminate"
              :value="checkAll"
              @click.prevent.native="handleCheckAll"> 全选</iv-checkbox>
          <span style="margin-right: 1em">已选 {{ selection.list.length }} 项目，所选项将</span>
          <span class="adm-buttons">
              <iv-button type="primary" :disabled="selection.list.length<=0" size="small" @click="reviewList('pass')">通过</iv-button>
              <iv-button type="primary" ghost size="small" v-if="selection.list.length<=0" :disabled="selection.list.length<=0">不通过</iv-button>
              <iv-poptip ref="selectionPoptipDown" v-model="selection.shown2" v-else>
              <iv-button type="primary" ghost size="small" :disabled="selection.list.length<=0">不通过</iv-button>
              <div slot="content" style="text-align: left;">
                  <iv-form label-position="top">
                  <iv-form-item label="审核批注（选填）">
                      <iv-input type="textarea" v-model="selection.comment" />
                  </iv-form-item>
                  <div class="adm-buttons" style="text-align:right">
                      <iv-button type="text" size="small" @click="closeSelectionPoptip('selectionPoptipDown')">
                      取消
                      </iv-button>
                      <iv-button type="primary" size="small" @click="reviewList('fail');closeSelectionPoptip('selectionPoptipDown')">
                      发送
                      </iv-button>
                  </div>
                  </iv-form>
              </div>
              </iv-poptip>
          </span>
        </iv-card>

        <div slot="footer">
          <p>备注：新审核数据，需等1-2分钟生效</p>
          <template v-if="list.last_page > 1">
              <div slot="footer" class="pull-right">
                  <iv-page
                          @on-change="pageChanged"
                          :current="list.current_page"
                          :page-size="10"
                          show-elevator
                          show-total
                          :total="list.total">
                  </iv-page>
              </div>
          </template>
        </div>
        <EditListedSentimentModal
            v-model="sentimentModal.data"
            :shown="sentimentModal.shown"
            type="audit"
            @refresh="refresh"
            @shown-changed="sentimentModal.shown=$event">
        </EditListedSentimentModal>

        <router-view />
    </AdmPanel>
</template>

<script>
import ListedSentimentModel  from '@/models/ListedSentimentModel';
import IndustryModel from '@/models/IndustryModel'
import ListedTargetModel from "@/models/ListedTargetModel";
import AuditModel from "@/models/AuditModel";
import ModelMixin    from '@/mixins/Model.mixin';
import LoaderMixin   from '@/mixins/Loader.mixin';
import contact       from '@/utils/contact';
import { conditioner, defaultVal, unique, downloadByUrl, getLastMonth } from '@/utils/';
import ListedOpinionItem   from '@/components/ListedOpinionItem'
import EmptyData     from '@/components/EmptyData'
import EditListedSentimentModal     from '@/components/EditListedSentimentModal'
import Fecha         from '@/utils/type/Fecha'
import { audit, esg_ordering as ordering } from "@/configs/options.conf"

import CompanySelect from "@/components/CompanySelect"

window.getLastMonth = getLastMonth

const LISTED_SENTIMENT = ListedSentimentModel.ModelName; // remove '$'
const ModelName = LISTED_SENTIMENT;
const INDUSTRY = IndustryModel.ModelName
const LISTED_TARGET = ListedTargetModel.ModelName
const ADUIT = AuditModel.ModelName

const options = {
  year:[],
  industry:[],
  companys: [],
  sentiment_list:[
    { id:'负面' , title:'负面' },
    { id:'正面' , title:'正面' }
  ],
  confirmTag:[
      { id: "0", title: "待确认" },
      { id: "1", title: "收录" },
      { id: "2", title: "排除" },
  ],
  scoreTag:[
      { id: "0", title: "未评分" },
      { id: "1", title: "已评分" },
  ],
  audit,
  ordering,
}

const _conditioner = conditioner(
    {
      limit            : {type: Number, default: 10},
      offset           : {type: Number, default: 0},
      industryId       : {type: Number, default: ""},
      id               : {type: String, default: ""},
      stockCode        : {type: val=>val.join(''), default: ""},
      timeScope        : {type: val=> val.length <= 0 || val.every(item=>!item) ? '' : JSON.stringify(val.map(date=>Fecha.format(date,'YYYY-MM-DD'))) , default: ""},
      // targetListTag : {type: String, default: 1}, // more info see #315
      timestamp        : {type: val=>new Date().getTime(), default: ()=>new Date().getTime()},
      audit            : { type: Number, default: "" }
    },
    {
      limit            : {type: Number, default: 10},
      offset           : {type: Number, default: 0},
      industryId       : {type: Number, default: ""},
      id               : {type: String, default: ""},
      stockCode        : {type: val=>[val], default:[]},
      timeScope        : {type: val=> !val ? [] : JSON.parse(val).map(date=>Fecha.parse(date,'YYYY-MM-DD')), default: getLastMonth()},
      audit            : {type: String, default: "" }
    }
)
const filter_rules = [
  {name: 'industryId', type: "Select", options: [], title: '行业', default: "", placeholder: "行业",clearable:true, style: { width: "150px" }},
  {
    name: 'stockCode',
    type: 'CompanySelect',
    options: [],
    title: '公司',
    default: [],
    placeholder: '公司',
    clearable: true,
    filterable: true,
    style: { width: '200px' },
  },
  { name: 'audit', type: "Select", options: options.audit, title: '审核状态', default: '0', placeholder: "审核状态", style: { width: "150px" }},
  {name: 'id', type: "Input", title: '舆情编号', default: "", placeholder: "舆情编号", style: { width: "150px" }},
  {name: 'audit', type: "Select", options: options.audit, title: '审核状态',clearable:true, default: "", placeholder: "审核状态", style: { width: "90px" }},
  {name: 'ordering', type: "Select", options: options.ordering, title: '排序方式',clearable:true, default: "", placeholder: "排序方式", style: { width: "120px" }},
]

export default {
        name: "sentiment",
        mixins:[
            LoaderMixin(LISTED_SENTIMENT+'data',LISTED_SENTIMENT+'exportPublicSentiment',INDUSTRY),
            ModelMixin({
                contact,
                models:[
                    ListedSentimentModel,
                    IndustryModel,
                    ListedTargetModel,
                    AuditModel,
                ]
            })
        ],
        data() {
            return {
                conditions: {
                  ..._conditioner.default(),
                  companyInput: ''
                },
                ModelName,
                LISTED_SENTIMENT,
                INDUSTRY,
                LISTED_TARGET,
                ADUIT,
                list: {
                    data: [],
                    last_page:0,
                    current_page:1
                },
                options: {
                    ...options,
                    filter_rules,
                },
                source:{},
                sentimentModal:{
                    shown:false,
                    data:null
                },
                selection: {
                    list: [],
                    checkboxData: [],
                    comment: "",
                    shown: false,
                    shown2: false,
                },
                indeterminate: false,
                checkAll: false,
                CheckAllData:[],
                builder:{
                  'renderCompanySelect': (vm,h,{ fieldset, values } = {})=>{ //必须加`render`前序
                    return <CompanySelect
                      { ...{
                      style: fieldset.style,
                      props: {
                        ...fieldset,
                        value: values[fieldset.name] || fieldset.default,
                      },
                      on: {
                        'change': $event=>vm.onValueChanged($event, fieldset.name), //调用FilterBar对象内部函数
                      }
                      }}
                    ></CompanySelect>
                  }
                }
            }
        },
        async mounted () {
            const { query, params } = this.$route
            let conditions = _conditioner.serialize({...query,...params}) //处理成支持UI的格式

            const industries = await this.refreshIndustry()
            this.renderFilterBar("industryId", industries)

            // 初始条件

            await this.refreshfirstTarget()
            await this.refreshsecondTarget({
              firstTargetNum: this.conditions.firstTargetNum ? this.conditions.firstTargetNum : undefined
            })
            await this.refreshthirdTarget({
              firstTargetNum:this.conditions.firstTargetNum ? this.conditions.firstTargetNum : undefined,
              secondTargetNum: this.conditions.secondTargetNum ? this.conditions.secondTargetNum : undefined
            })

            this.conditions = conditions

            await this.refresh()
            await this.initCheckAll()
        },
        beforeRouteUpdate(to, from, next){
            this.$nextTick(async()=>{
                const { query, params } = to
                this.conditions = {
                    ..._conditioner.default(),
                    ..._conditioner.serialize({...query,...params}) //处理成支持UI的格式
                }

                if(to.path.indexOf('/logs')>-1||from.path.indexOf('/logs')>-1) return
                await this.refresh()
                await this.initCheckAll()
            })
            next();
        },
        methods: {
            async refresh(query=this.conditions){
                this.list              = await this.$$active(ModelName,"data", _conditioner.parse(query));
                this.list.current_page = _conditioner.parse(query).offset ? _conditioner.parse(query).offset / _conditioner.parse(query).limit + 1 : 1
                this.list.last_page    = this.list.total / _conditioner.parse(query).limit
                this.selection.checkboxData = []
                this.selection.list = []
            },
            initCheckAll(){
                this.indeterminate = false,
                this.list.data.map(item=>{this.CheckAllData.push(item.id)})
            },
            renderFilterBar(fieldName, val, defaults){
                const fieldset = this.options.filter_rules.find(fieldset=>fieldset.name===fieldName)
                fieldset.options = val
            },
            async refreshIndustry(params = this.$route.params){
                let industries;
                const industry = await this.$$fetch(INDUSTRY,{ type:'listed',params })
                if(industry) industries = industry.data.map(item=>({...item, name: item.industry}))
                return this.options.industry = industries
            },
            async refreshfirstTarget(params = this.$route.params){
                const firstTarget = await this.$$active(LISTED_TARGET, 'firstTarget',{ ...params })
                if(firstTarget)  this.options.firstTargets = firstTarget.data
            },
            async refreshsecondTarget(params = this.$route.params){
                const secondTarget = await this.$$active(LISTED_TARGET, 'secondTarget',{ ...params })
                if(secondTarget)  this.options.secondTargets = secondTarget.data
            },
            async refreshthirdTarget(params = this.$route.params){
                const thirdTarget = await this.$$active(LISTED_TARGET, 'thirdTarget',{ ...params })
                if(thirdTarget)  this.options.thirdTargets = thirdTarget.data
            },
            changeQuery(query=this.conditions, params = this.$route.params) {
                this.$router.push({
                    name  : this.$route.name,
                    query: {..._conditioner.parse({ ...query}), offset:0},
                    params: params
                });
            },
            pageChanged(page){
                this.$router.push({ name: this.$route.name, query: { ...this.$route.query, offset: ( page - 1 ) *  _conditioner.parse(this.conditions).limit}, params: this.$route.params });
            },
            async confirm(params,val, active=false){
                this.sentimentModal.data = params
                if(val ==1) this.sentimentModal.shown = true;
            },
            async exclude(params,val){
              const result = await this.$$active(ModelName, 'confirm', {id : params.id, is_confirm: val})
              if(result instanceof Error) return
              this.refresh()
            },
            async title(params){
                const Keyword = await this.$$active(ModelName, 'title', {id : params.id, title: params.title})
                const item = this.list.data.filter(tag=>tag.id == params.id)
                item[0].title = params.title
            },
            onTableSelected(selection){
                this.selection.list = selection
            },
            async review(action_name, item){
                const { id,comment } = item
                const target = { idList:[id], audit:0, comment }
                switch(action_name){
                    case 'pass':
                        target.audit = 3
                        break;
                    case 'fail':
                        target.audit = 2
                        break;
                }
                try{
                    this.$$loading(ADUIT);
                    await this.$$active(ADUIT, 'batchlistedSentiment', target)
                    this.$$loaded(ADUIT);
                }catch(e){
                    this.$$error(e)
                }
                this.refresh()
            },
            async reviewList(action_name, comment=this.selection.comment ,selection=this.selection.list){
                const audit = ['','','fail','pass'].indexOf(action_name)
                const items = selection.filter(item=>item.audit!=audit).map(item=>({ ...item, comment, audit }))
                this.selection.comment = ""
                if(items.length<=0){
                    return this.$$error(new Error(`已选的${selection.length ? selection.length : '1'}项，所选项已是${['','','不通过','通过'][['','','fail','pass'].indexOf(action_name)]}状态`))
                }
                try {
                    this.$$loading(ADUIT);
                    await this.$$active(ADUIT, "batchlistedSentiment", { comment, audit, idList:items.map(item=>item.id) });
                    this.$$loaded(ADUIT);
                } catch (e) {
                    this.$$error(e);
                }
                this.refresh();
            },
             async exportExcel(query = this.conditions) {
              // TODO:
              console.log("exportExcel...", this.conditions)
              const res = await this.$$active(ModelName, 'dataExport', _conditioner.parse(query))
              if(!res.data.url) {
                this.$$info('后台未返回url，请重试')
                return
              }
              console.log(res.data.url,'res.data.url')
              // 下载链接
              downloadByUrl(res.data.url)
            },
            checkboxData(){
                this.selection.list = []
                this.selection.checkboxData.map(item=> this.selection.list.push((this.list.data.filter(i=>i.id==item))[0]))
                this.checkAllGroupChange(this.selection.list)
            },
            closeSelectionPoptip(ref){
              this.$refs[ref].visible = false
            },
            handleCheckAll () {
                if (this.indeterminate) {
                    this.checkAll = false;
                } else {
                    this.checkAll = !this.checkAll;
                }
                this.indeterminate = false;

                if (this.checkAll) {
                    this.selection.checkboxData = this.CheckAllData
                    this.selection.list = this.list.data
                } else {
                    this.selection.checkboxData = [];
                    this.selection.list = [];
                }
            },
            checkAllGroupChange (data) {
                if (data.length === this.list.data.length) {
                    this.indeterminate = false;
                    this.checkAll = true;
                } else if (data.length > 0) {
                    this.indeterminate = true;
                    this.checkAll = false;
                } else {
                    this.indeterminate = false;
                    this.checkAll = false;
                }
            },
            jumpToEdit(item){
              const route = this.$router.resolve({ name: 'market_sentiment_input', query: _conditioner.parse({ id: item.id, timeScope:this.conditions.timeScope }), params:{sourceTag:0} })
              console.log(route)
              window.open(route.href)
            }
        },
        watch:{
            'conditions.sourceTag'(val) {
              this.refresh()
            },
        },
        computed: {
            isAudit() {
                return this.$route.matched.some(item => item.name == "audit");
            }
        },
        components:{
            ListedOpinionItem,
            EmptyData,
            EditListedSentimentModal,
            CompanySelect
        }
    }
</script>

<style lang="scss" scoped>
.filter-wrapper {
  position: relative;
  margin-bottom: 20px;
  .export-excel-btn {
    position: absolute;
    right: 0;
    top: 0;
  }
}
.nextPage{
    margin: 15px 0;
    display: flex;
    justify-content: center;
    text-align: center;
    button{
        width: 200px;
    }
}
</style>
